import { getSupabaseClient } from "./supabaseClient.js";

export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

export const mastraBaseUrl =
  import.meta.env.VITE_MASTRA_BASE_URL || "http://localhost:4111";

export async function getSessionAccessToken() {
  // getSession() will use the refresh token to get a new session if accessToken has expired
  const result = await getSupabaseClient().auth.getSession();
  const session = result.data.session;

  if (!session) {
    throw new Error("Attempting to make a request with no session");
  }

  return session.access_token;
}

export async function getApiAuthorizationHeaderValue() {
  const token = await getSessionAccessToken();

  return `Bearer ${token}`;
}
